export default "__VITE_ASSET__ZABemyNV__"